import { render } from "./MultipleChoiceGridComponent.vue?vue&type=template&id=5acf0ef6"
import script from "./MultipleChoiceGridComponent.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__